import React from "react";
import "./terms.css";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
<main dir="rtl" lang="he" className="container legal-page" role="main" aria-labelledby="a11y-title">
      <a href="#content" className="sr-only-focusable">דלג לתוכן</a>
      <h1 id="terms-title">תקנון ותנאי שימוש</h1>
      <div id="a11y-title">הצהרת נגישות</div>
            <div className="logo-container-sign">
        <Link to="/">
          <img src="/icons/green-logo.png" alt="Logo" className="logo" />
        </Link>
      </div>
      <section id="content" aria-labelledby="general">
        <h2 id="general">1. כללי</h2>
        <p>השימוש בשירות Heyi מהווה הסכמה לתקנון. נוסח בלשון זכר לנוחות, אך פונה לכל המגדרים.</p>
      </section>

      <section aria-labelledby="use">
        <h2 id="use">2. שימוש בשירות</h2>
        <ul>
          <li>שימוש אישי וחוקי בלבד; אין להעלות תוכן פוגעני/מפר זכויות.</li>
          <li>Heyi רשאית להסיר תכנים המפרים תנאים.</li>
        </ul>
      </section>

      <section aria-labelledby="ip">
        <h2 id="ip">3. קניין רוחני ותמונות משתמש</h2>
        <p>
          זכויות הפלטפורמה שייכות ל-Heyi. זכויות התמונות נשארות של המעלה; עם ההעלאה
          ניתנת לחברה הרשאת שימוש לצורך מתן השירות (שמירה, עיבוד, הצגה).
        </p>
      </section>

      <section aria-labelledby="privacy">
        <h2 id="privacy">4. פרטיות ואבטחת מידע</h2>
        <p>
          נתונים נשמרים בהתאם לחוק הגנת הפרטיות ול-GDPR, ב-AWS / מסד נתונים מאובטח.
          לא נמסור לצד שלישי אלא על פי דין. פירוט במדיניות הפרטיות.
        </p>
      </section>

      <section aria-labelledby="liability">
        <h2 id="liability">5. אחריות</h2>
        <p>השירות ניתן "כפי שהוא" (AS-IS). ייתכנו תקלות/השבתות. האחריות מוגבלת לפי דין.</p>
      </section>

      <section aria-labelledby="contact">
        <h2 id="contact">6. יצירת קשר</h2>
        <p>
          שאלות?{" "}
          <a href="mailto:heyi.events@gmail.com">heyi.events@gmail.com</a> |{" "}
          <a href="tel:+972542001485">054-2001485</a>
        </p>
        <p>תאריך עדכון אחרון: 10.09.2025</p>
      </section>
    </main>
  );
}
